var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getTestSelector } from '../../utilities/tests';
var Button = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, onClick = _a.onClick, disabled = _a.disabled, id = _a.id, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.buttonStyle, buttonStyle = _d === void 0 ? 'primary' : _d, _e = _a.buttonColor, buttonColor = _e === void 0 ? 'orange' : _e, additionalProps = _a.additionalProps, _f = _a.testSelector, testSelector = _f === void 0 ? getTestSelector(id || (typeof children === 'string' ? children : 'not-identified'), 'button') : _f;
    return (_jsx("button", __assign({ "data-cy": testSelector, className: "".concat(buttonColor, " ").concat(buttonStyle, " ").concat(className, " rounded-md"), onClick: onClick, type: type, disabled: disabled, id: id }, additionalProps, { "data-public": "true", children: children })));
};
export { Button as default };
